export default function objectContainsChanges(updatedValues, originalObject) {
  return Object.keys(updatedValues).some((key) => {
    return updatedValues[key] !== originalObject[key]
  })
}
